import React, { useMemo } from "react";
import CardList from "../../Courses/components/CardList/CardList";
import TrainingCardList from "../../Courses/components/TrainingCardList/TrainingCardList";
import { useState } from "react";
import { Layout, Tabs } from "antd";
import "./CoursesAndPlanification.css";
import CourseSkillsAssignment from "../../Courses/components/CourseSkillsAssignment/CourseSkillsAssignment";

const CoursesAndPlanification = () => {
  const [name, setName] = useState("Courses");

  const onChangeHeaderName = (key) => {
    switch (key) {
      case "1":
        setName("Courses");
        break;
      case "2":
        setName("Trainings");
        break;
      case "3":
        setName("Course Skills");
        break;
      default:
        setName("Courses");
    }
  };

  const items = useMemo(
    () => [
      {
        key: "1",
        label: `Courses`,
        children: <CardList nameSection="Course" />,
      },
      {
        key: "2",
        label: `Trainings`,
        children: (
          <TrainingCardList nameSection="Training" isUpcomingTraining={false} />
        ),
      },
      {
        key: "3",
        label: `Course Skills`,
        children: <CourseSkillsAssignment />,
      },
    ],
    []
  );
  return (
    <Layout pagename={name}>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChangeHeaderName}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
    </Layout>
  );
};

export default CoursesAndPlanification;
